//requires: public\pclm-map-helper.js
/**
 * 
 */
jQuery(document).ready(function($){
	mapsManager.registerForEvents(overlayManager);
});
var overlayManager={
		
		_overlays_layers : {},
		_eventManager: eventManager,
		_selectionStyle: {color: "#ff7800", weight: 1},
		
		//overlayStatus:{draft:'draft',pending:'pending',future:'future',publish:'publish',private:'private',trash:'trash',autoDraft:'auto-draft',inherit:'inherit'},
		//overlayVisibility:{public:'public',password:'password',private:'private'},
		
		init: function(){
			
			var mapsHtmlId = mapsManager.searchMapOnPage(mapsManager.get_map_id_prefix());
			
			this._behaviours = new L.Behaviours();
			
			mapsHtmlId.each(function() {
				jQuery.get(ajax_object.ajaxurl,
					{	
						"action":"overlays_data",
						"id": this.id 
					},
					function(data){
						// For every overlay got from db
						for (var overlaysIdx in data.overlays){
							
							var leafletData = JSON.parse(data.overlays[overlaysIdx]['leaflet_data']);
							var leafletDataProperties =  leafletData['properties'];
							var leafletDataOptions =  leafletData['options'];
							
							//TODO replace with right code : hack to be selectable
							leafletDataOptions['interactive']=true;
													
							var overlay = L.imageOverlay(leafletDataProperties['url'], leafletDataProperties['bounds'],leafletDataOptions);
							
							var postData = data.overlays[overlaysIdx]['post'];
							
							overlay.publication.setPostId(postData['ID']);
							overlay.publication.setParent(postData['post_parent']);
							overlay.publication.setStatut(postData['post_status']);
							overlay.publication.setDate(postData['post_date']);
							overlay.publication.setDateGMT(postData['post_date_gmt']);
							//overlay.publication.setVisibility(postData['post_visibility']);
							overlay.publication.setPassword(postData['post_password']);
							
							if (data.overlays[overlaysIdx]['behaviours']){
								var behavioursData = JSON.parse(data.overlays[overlaysIdx]['behaviours']);
								overlayManager._behaviours.setBehaviours(overlay,behavioursData);
							}	
							
							// TODO refactor
							//overlay.bindEnhancedContent(enhancedContent);
							overlayManager.addToFeaturesGroup(overlay);
						}

					},
					"json"
				);
			});
		},
		
		
		addOverlay: function(mapId, overlay){
			if((overlay!= null) && (mapId != -1)){
				overlay.publication.setParent(mapId.replace(mapsManager.get_map_id_prefix()+'-',''));
				this._behaviours.setBehaviours(overlay,{'onClick':{type: "none",'options':{}},'onOver':{type: "none",'options':{}}});
				overlayManager.addToFeaturesGroup(overlay);
				
			}
		},
		
		initFeatureGroup:function(mapId){
			overlayManager._overlays_layers[mapId] = new L.FeatureGroup();
			var returnedLayer  = mapsManager.setLayer(mapId,overlayManager._overlays_layers[mapId]);
		},
		
		getFeaturesGroup: function(mapId){
			
			var mapId = mapId || null;
			// if no mapId return all overlays
			if (mapId==null){
				return overlayManager._overlays_layers;
			}else{
				var mapHtmlId = mapsManager.getMapHtmlId(mapId);
				// if mapId return the corresponding overlays group
				if (!overlayManager._overlays_layers[mapHtmlId]){
					//init group if don't exist
					overlayManager.initFeatureGroup(mapHtmlId);
					return overlayManager._overlays_layers[mapHtmlId];
				}else{
					return overlayManager._overlays_layers[mapHtmlId];
				}
				
			}
		},
		
		addToFeaturesGroup: function(layer){
			layer.isDisplayAllowed= function(){return true};
//			layer.on('mouseover',overlayManager.onLayerOver);
//			layer.on('mouseout',overlayManager.onLayerOut);
			//layer.on('click', overlayManager.onLayerClick);
			overlayManager.getFeaturesGroup(layer.publication.getParent()).addLayer(layer);
		},
		
		setDrawMode: function(mapId){
			var featureGroup = overlayManager.getFeaturesGroup(mapId);
			featureGroup.eachLayer(function(layer){
				layer.suspendModalOpening(true);
				layer.suspendPopupOpening(true);
			});
		},
		
		unsetDrawMode: function(mapId){
			var featureGroup = overlayManager.getFeaturesGroup(mapId);
			featureGroup.eachLayer(function(layer){
				layer.suspendModalOpening(false);
				layer.suspendPopupOpening(false);
			});
		},
		
		onLayerOver: function(event){
			var bounds = event.target.getBounds();
			jQuery(event.target._image).css('transition','0.5s');
			jQuery(event.target._image).css('transform-origin','center');
			jQuery(event.target._image).css('transform',overlayManager.grow);
			
//			event.target.setBounds(bounds.pad(0.05));
		},
		
		onLayerOut: function(event){
			var bounds = event.target.getBounds();
			jQuery(event.target._image).css('transform',overlayManager.reduce);
			jQuery(event.target._image).css('transition','');
//			event.target.setBounds(bounds.pad(-(1-1/(1+(0.05*2)))/2));			
		},
		
//		grow(index, value){
//			return	toReturn = value.concat(' scale(1.02)');
//		},
//		
//		reduce(index, value){
//			return	toReturn = value.concat(' scale('+ 1/1.02 +')');
//		},
		
		
		handleEvents : function(e){
				this.init();
		},
		
		registerForEvents : function (element){
			overlayManager._eventManager.register(element);
		},
		
}



L.ImageOverlay.include({
	getCenter: function(){
		return this.getBounds().getCenter();
	}
});
